import { useCallback } from 'react';
import { SortColumnDto } from '@asset-metrix/portal-gateway-client-js';
import { useShallow } from 'zustand/react/shallow';

import { useStore } from '../store';

export function usePersistentSorting(
  pageFilterInstanceId: string,
  widgetFilterInstanceId: string,
  sortColumns: SortColumnDto[]
) {
  const [currentSortItemsStore, setCurrentSortItemsStore] = useStore(
    useShallow((state) => [
      state.sortColumns[pageFilterInstanceId]?.[widgetFilterInstanceId] ??
        sortColumns,
      state.setSortColumns,
    ])
  );

  const setCurrentSortItems = useCallback(
    (items: SortColumnDto[]) => {
      setCurrentSortItemsStore(
        pageFilterInstanceId,
        widgetFilterInstanceId,
        items
      );
    },
    [setCurrentSortItemsStore, widgetFilterInstanceId, pageFilterInstanceId]
  );

  return {
    currentSortItems: currentSortItemsStore,
    setCurrentSortItems,
  };
}
